import React, { Component } from 'react';
import {Form, Control, Errors} from "react-redux-form";
import { isRequired } from "../field_validations";
import _ from "lodash";
import Rating from 'react-rating';

class RoleEditForm extends Component {
	render(){
		const { roles, permissions } = this.props;
		let roleDisabled = roles.edit && _.isNumber(roles.edit.editable) ? !roles.edit.editable:false;
		return(
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="roles.edit" onSubmit={(values) => this._handleSubmit(values)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field is-grouped">
							<div className="control is-expanded">
								<label htmlFor="display" className="label">Nombre del perfil <span className="small has-text-danger">*</span></label>
								<Control.text model=".display" id="display" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".display" show="touched"  wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre del perfil es obligatorio'}} />
							</div>

							<div className="control">
								<label htmlFor="agenciable_type" className="label">Tipo de perfil</label>
								<div className="select">
									<Control.select model=".agenciable_type" id="agenciable_type" disabled={roleDisabled} value={!_.isEmpty(roles.edit.agenciable_type) ? roles.edit.agenciable_type:""}>
										<option value="">-Todos-</option>
										<option value="federal">Federal</option>
										<option value="imef">IMEF</option>
										<option value="imm">IMM</option>
									</Control.select>
								</div>
							</div>
						</div>

						<div className="hero is-light">
							<div className="hero-body">
								<h5 className="title is-5">Listado de Permisos del Perfil <span className="small has-text-danger">*</span></h5>
								{!_.isEmpty(permissions.list) ?
									_.map(permissions.list, (item,k) => {
										return (
											<div key={k}>
												<div className="box is-radiusless" onClick={() => {this._showGroup(item.id)}} >
													<div className="level">
														<div className="level-left">
															<div className="level-item">
																<div>
																	<p className="heading">Grupo</p>
																	<p className="title is-6 has-text-inm-purple">{item.name}</p>
																</div>
															</div>
														</div>
														<div className="level-right">
															<div className="level-item">
																<span className="icon">
																	{this.state.groupId === item.id && this.state.showGroup ?
																		<i className="fa fa-angle-up fa-lg"/>
																		: <i className="fa fa-angle-down fa-lg"/>}
																</span>
															</div>
														</div>
													</div>
												</div>
												{this.state.groupId === item.id && this.state.showGroup ?
													<table className="table is-fullwidth" style={{marginBottom:'15px'}}>
														<tbody>
														{_.map(item.permissions, (p,i) => {
															let initial = _.findKey(roles.edit.permissions, {id:p.id}) !== undefined ? 1 : 0;
															return (
																<tr key={i}>
																	<td>
																		<div className="control" onClick={() => this._addPermission(p.id)}>
																			<Rating
																				ref={`permission-${p.id}`}
																				id={`permission-${p.id}`}
																				initialRating={initial}
																				start={0}
																				stop={1}
																				step={1}
																				emptySymbol="fa fa-square-o fa-lg"
																				fullSymbol="fa fa-check-square-o fa-lg"
																				className="has-text-primary"
																			/>
																		</div>
																	</td>
																	<td><label htmlFor={`permission-${p.id}`}>{p.display ? p.display : p.name}</label></td>
																</tr>
															)
														})}
														</tbody>
													</table> :''}
											</div>
										)
									})
									:''}
							</div>
						</div>

						<br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-light is-large" onClick={() => this.props.history.push('/perfiles')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="roles.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	constructor(){
		super();
		this.state= {
			groupId: undefined,
			showGroup: false
		}
	}

	_showGroup(id) {
		if (id !== this.state.groupId) {
			this.setState({
				groupId: id,
				showGroup: true
			})
		} else {
			this.setState({
				groupId: undefined,
				showGroup: false
			})
		}
	}

	_addPermission(permisionId){
		let {permissions} = this.props.roles.edit;

		let permissionIndex = _.findIndex(permissions, {id: permisionId});
		if(this.refs[`permission-${permisionId}`].state.value === 0){
			if(permissionIndex === -1){
				this.props.add(`roles.edit.permissions`,{
					id: permisionId
				})
			}else {
				this.props.change(`roles.edit.permissions[${permissionIndex}]`,{
					id: permisionId
				})
			}
		}else{
			if(permissionIndex !== -1){
				this.props.remove(`roles.edit.permissions`,permissionIndex)
			}
		}
	}

	_handleSubmit(values) {
		this.props.roleSave(values);
	}

	_validateSave(){
		const {roles} = this.props;
		let rc = _.find(roles.permissions, (o) => {return o==='Create'});
		let ru = _.find(roles.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(roles.edit) && roles.edit.id){
			if(ru){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(roles.edit) && _.isEmpty(roles.edit.id)){
			if(rc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default RoleEditForm;


// WEBPACK FOOTER //
// ./src/elements/roles/form.jsx